// setup-default-tools-on-init.ts
//
// Bước init: BẬT TẤT CẢ tool có trong pack — KHÔNG hỏi từng cái.
//
// Lý do (user chốt 2026-06-13): đã có `avatar tools list/enable/disable` để user
// gỡ bất kỳ lúc nào → hỏi từng tool lúc init là thừa. Cài tất cả là mặc định.
//
// - Nguồn tool = quét pack/tools/*/tool.json (listAvailableTools), KHÔNG phải
//   danh sách cứng trong defaults.json. Thêm tool mới vào pack → tự bật.
// - Fail-mềm: pack chưa có tools/ → rỗng → no-op im lặng.

import { listAvailableTools } from "./discover-pack-tools-and-defaults.js";
import { log } from "./terminal-logger.js";
import { enableToolByName } from "./tool-enable-disable-orchestrator.js";

export async function setupDefaultToolsOnInit(
  workspacePath: string,
  // opts giữ để tương thích caller (autoYes không còn ảnh hưởng — luôn bật).
  _opts: { autoYes?: boolean } = {},
): Promise<void> {
  const available = await listAvailableTools(workspacePath);
  if (available.length === 0) {
    return; // pack chưa có tools/ → no-op.
  }
  const toEnable = available;

  log.info(`Bật ${toEnable.length} tool mặc định (gỡ sau bằng 'avatar tools disable <tên>')...`);
  for (const name of toEnable) {
    // silent: tool có thể thiếu trong pack cũ → không spam warning.
    await enableToolByName(workspacePath, name, { silent: true });
    log.dim(`  ✓ ${name}`);
  }
}
